import HeroWithMedia from '@rsa-digital/evo-shared-components/components/Hero/HeroWithMedia';
import {
  Heading,
  MediaContainer,
  TextContent,
} from '@rsa-digital/evo-shared-components/components/Hero/HeroWithMedia/styles';
import HeroWithResponsiveMedia from '@rsa-digital/evo-shared-components/components/Hero/HeroWithResponsiveMedia';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import { fonts } from '@rsa-digital/evo-shared-components/theme/RSA/fonts';
import styled, { css } from 'styled-components';

const commonHeroWithMediaStyle = css`
  ${TextContent} {
    margin-top: 0;
  }

  ${Heading} {
    font-size: 52px;
    line-height: 60px;
    margin-top: ${spacing(3)};
    margin-bottom: 0;
    padding-bottom: ${spacing(2)};

    ${mediaQuery.tabletPortrait`
      ${fonts.headingXLarge}
      font-size: 72px;
      line-height: 80px;
    `}

    ${mediaQuery.tabletLandscape`
      margin-top: ${spacing(8)}; 
    `}
  }
`;

export const StyledHeroWithMedia = styled(HeroWithMedia)`
  ${commonHeroWithMediaStyle}

  padding-bottom: 0;
  margin-bottom: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(4)};
  `}

  ${MediaContainer} {
    padding-top: ${spacing(3)};
    ${mediaQuery.tabletLandscape`
      padding-top: ${spacing(4)};
    `}

    figure {
      padding-top: 0;
    }
  }
`;

export const StyledHeroWithResponsiveMedia = styled(HeroWithResponsiveMedia)`
  ${commonHeroWithMediaStyle}
`;
